<template>
  <div class="countdown">
    <div class="countdown-wrapper">
      <div class="countdown-timer">
        <div class="countdown-timer__value">{{ days }}</div>
        <div class="countdown-timer__divider" v-if="days">:</div>
        <div class="countdown-timer__value">{{ hours }}</div>
        <div class="countdown-timer__divider">:</div>
        <div class="countdown-timer__value">{{ minutes }}</div>
        <div class="countdown-timer__divider">:</div>
        <div class="countdown-timer__value">{{ seconds }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    value: Object
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null
    };
  },
  created() {
    this.startCountdown();
  },
  methods: {
    startCountdown() {
      this.calc();

      this.interval = setInterval(() => {
        this.calc();
      }, 1000);
    },
    daysWithoutMonths(ms) {
      let days = Math.floor(ms / 1000 / 60 / 60 / 24);
      if (days < 0) days = 0;
      return days;
    },
    calc() {
      const release = this.$moment(this.value.release_date);
      const today = this.$moment(new Date());
      const diff = release.diff(today);
      const duration = this.$moment.duration(diff, "milliseconds");

      const days = this.daysWithoutMonths(diff);
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
        this.$emit("update");
      }

      this.days = days;
      this.hours = hours < 10 ? "0" + hours : hours;
      this.minutes = minutes < 10 ? "0" + minutes : minutes;
      this.seconds = seconds < 10 ? "0" + seconds : seconds;
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.countdown-wrapper {
  min-height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  color: $primary;
  margin-left: 120px;
}

.countdown-timer {
  font-weight: 300;
  font-size: 36px;
  line-height: 1.167;
  display: flex;
  align-items: center;
  &__value {
    min-width: 1.23em;
    text-align: center;
  }
}

@media screen and (max-width: 1264px) {
  .countdown-wrapper {
    margin-left: 56px;
  }
}

@media screen and (max-width: 960px) {
  .countdown-wrapper {
    margin-left: 0;
    justify-content: center;
  }
}
</style>
